import "./RemoveDeletedNotes.scss";

function RemoveDeletedNotes({ cancelRemoveDeletedNotes, removeDeletedNotes }) {
  return (
    <div className="remove-deleted-notes-content">
      <div className="modal-title">
        <div>Delete Deleted Notes</div>
      </div>
      <div className="modal-body">
        <p>Are you sure you want to permanently delete all deleted notes?</p>
        <p>
          <strong>This action cannot be undone.</strong>
        </p>
      </div>
      <div className="modal-form-buttons">
        <button
          className="modal-button cancel"
          onClick={cancelRemoveDeletedNotes}
        >
          Cancel
        </button>
        <button className="modal-button delete" onClick={removeDeletedNotes}>
          Delete
        </button>
      </div>
    </div>
  );
}

export default RemoveDeletedNotes;
